import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CheckListsComponent } from './components/check-lists/check-lists.component';

const routes: Routes = [{ path: '', component: CheckListsComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CheckListsRoutingModule {}
